<form [formGroup]="form">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <!--DIV DATOS-->
            <div class="card">
                <div class="card-header">
                    <h3><label>{{ 'datos' | translate }}</label></h3>
                    <div class="plegarpanel"></div>
                </div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group mr-2" style="width: 30%">
                            <kendo-label text="{{ 'referencia' | translate}}">
                                <div class="caja">
                                    <kendo-textbox formControlName="referencia" maxlength="150"
                                        [ngClass]="{ 'is-invalid': submitted && f.referencia.errors }">
                                    </kendo-textbox>
                                    <div *ngIf="submitted && f.referencia.errors" class="invalid-feedback">
                                        <div *ngIf="f.referencia.errors.required">{{ 'referenciaEsRequerida' |
                                            translate}}</div>
                                    </div>
                                </div>
                            </kendo-label>
                        </div>
                        <div class="form-group mr-2" style="width: 30%">
                            <kendo-label text="{{ 'nombre' | translate}}">
                                <div class="caja">
                                    <kendo-textbox formControlName="nombre" maxlength="150"
                                        [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }">
                                    </kendo-textbox>
                                    <div *ngIf="submitted && f.nombre.errors" class="invalid-feedback">
                                        <div *ngIf="f.nombre.errors.required">{{ 'nombrerequerido' |
                                            translate}}</div>
                                    </div>
                                </div>
                            </kendo-label>
                        </div>
                        <div class="form-group mr-2" style="width: 30%">
                            <kendo-label text="{{ 'tiposActivo' | translate}}">
                                <div class="caja">
                                    <kendo-combobox clearButton="true" valuePrimitive="true" [disabled]="!activosTipos"
                                        [data]="activosTipos" [allowCustom]="false" [(value)]="selectedTipoActivo"
                                        class="form-control" textField="nombre" valueField="id">
                                    </kendo-combobox>
                                </div>
                            </kendo-label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group mr-2" style="width: 30%">
                            <kendo-label text="{{ 'jerarquiaActivos' | translate}}">
                                <div class="caja">
                                    <kendo-combobox clearButton="true" valuePrimitive="true"
                                        [disabled]="!jerarquiaActivos" [(value)]="selectedJerarquiaActivo"
                                        [data]="jerarquiaActivos" [allowCustom]="false" class="form-control"
                                        textField="tipo" valueField="id">
                                    </kendo-combobox>
                                </div>
                            </kendo-label>
                        </div>
                        <div class="form-group mr-2" style="width: 30%">
                            <kendo-label text="{{ 'EAN' | translate}}">
                                <div class="caja">
                                    <kendo-textbox formControlName="codigoEAN" maxlength="150">
                                    </kendo-textbox>
                                </div>
                            </kendo-label>
                        </div>
                        <div class="form-group mr-2" style="width: 15%">
                            <kendo-label text="{{ 'vidaUtil' | translate}}">
                                <div class="caja">
                                    <kendo-numerictextbox class="form-control" formControlName="vidaUtil" [min]="0.0"
                                        [max]="999.0" [autoCorrect]="true" [step]="0.1">
                                    </kendo-numerictextbox>
                                </div>
                            </kendo-label>
                        </div>
                        <div class="form-group">
                            <label>{{ 'stock' | translate }}</label>
                            <div class="caja" style="margin: 0 0 0 7px;">
                                <kendo-switch [(ngModel)]="form.value.stock" formControlName="stock" [onLabel]="' '"
                                    [offLabel]="' '"></kendo-switch>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <!--OBSERVACIONES-->
                        <div class="form-group col">
                            <label class="check-label">{{ 'observacion' | translate }}</label>
                            <div class="checkbox">
                                <textarea formControlName="observaciones" class="form-control"
                                    style="height: 7em;"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <!--DIV imagen-->
            <div class="card">
                <div class="card-header">
                  <h3>
                    <label>{{ 'imagen' | translate }}</label>
                  </h3>
                  <div class="plegarpanel"></div>
                </div>
                <div class="card-body">
                  <!--IMAGEN VIEJA-->
                  <div>
                    <img [src]="imageToShow" style="max-height: 113px">
                  </div>
                  <div class="form-group w-50">
                    <div class="caja">
      
                      <kendo-fileselect formControlName="archivo" [restrictions]="restrictionsImage" [multiple]="false" (select)="archivoSeleccionado($event)" (remove)="archivoEliminado($event)">
                        <kendo-upload-messages cancel="{{ 'cancelar' | translate }}"
                                               clearSelectedFiles="{{ 'clearSelectedFiles' | translate }}"
                                               dropFilesHere="{{ 'dropFilesHere' | translate }}"
                                               externalDropFilesHere="{{ 'externalDropFilesHere' | translate }}"
                                               fileStatusFailed="{{ 'fileStatusFailed' | translate }}"
                                               fileStatusUploaded="{{ 'fileStatusUploaded' | translate }}"
                                               filesBatchStatus="{{ 'filesBatchStatus' | translate }}" 
                                               filesBatchStatusFailed="{{ 'filesBatchStatusFailed' | translate }}"
                                               filesBatchStatusUploaded="{{ 'filesBatchStatusUploaded' | translate }}"
                                               headerStatusPaused="{{ 'headerStatusPaused' | translate }}"
                                               headerStatusUploaded="{{ 'headerStatusUploaded' | translate }}"
                                               headerStatusUploading="{{ 'headerStatusUploading' | translate }}"
                                               invalidFileExtension="{{ 'invalidFileExtension' | translate }}"
                                               invalidMaxFileSize="{{ 'invalidMaxFileSize' | translate }}"
                                               invalidMinFileSize="{{ 'invalidMinFileSize' | translate }}"
                                               pause="{{ 'pause' | translate }}"
                                               remove="{{ 'remove' | translate }}"
                                               resume="{{ 'resume' | translate }}"
                                               retry="{{ 'retry' | translate }}"
                                               select="{{ 'select' | translate }}"
                                               uploadSelectedFiles="{{ 'uploadSelectedFiles' | translate }}">
                        </kendo-upload-messages>
                      </kendo-fileselect>
      
                    </div>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">

            <!--ISOMETRICO-->
            <div class="card">
                <div class="card-header">
                    <h3>
                        <label>{{ 'isometrico' | translate }}</label>
                    </h3>
                    <div class="plegarpanel"></div>
                </div>
                <div class="card-body">
                    <div class="activos-detalle-isometrico clearfix" [ngStyle]="{'text-align':'center'}">
                        <img class="clickable" (click)="abrirModal()"
                                        src="{{selectedDibujo.imagen}}" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loadingForm || loadingForm0" class="k-i-loading"></div>
    <div id="tabs" *ngIf="idActivoMaestro != 0">
        <kendo-tabstrip [keepTabContent]="true">
            <kendo-tabstrip-tab id="tabActivosAsociados" title="{{ 'activosAsociados' | translate}}" [selected]="true">
                <ng-template kendoTabContent>
                    <kendo-grid [kendoGridBinding]="dataAsociadosPadres" [sortable]="true" [navigable]="true"
                        filterable="menu">
                        <kendo-grid-column width="20%" field="nombre" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="referencia" title="{{ 'referencia' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="jeraraquiaActivo"
                            title="{{ 'jerarquiaActivos' | translate}}"> </kendo-grid-column>
                        <kendo-grid-column width="20%" field="vidaUtil" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column field="stock" title="{{ 'stock' | translate}}" width="10%">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" [checked]="dataItem.stock" disabled />
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column [style]="{'text-align': 'right'}"  width="10%">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              <button type="button" class="btn-icon" (click)="viewUpperTree(dataItem)" ><i class="fa fa-sitemap" aria-hidden="true"></i></button>
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-messages filter="{{'filter' | translate}}" filterAfterOperator="{{'filterAfterOperator' | translate}}"
                          filterAfterOrEqualOperator="{{'filterAfterOrEqualOperator' | translate}}"
                          filterAndLogic="{{'filterAndLogic' | translate}}" filterBeforeOperator="{{'filterBeforeOperator' | translate}}"
                          filterBeforeOrEqualOperator="{{'filterBeforeOrEqualOperator' | translate}}"
                          filterBooleanAll="{{'filterBooleanAll' | translate}}" filterClearButton="{{'filterClearButton' | translate}}"
                          filterContainsOperator="{{'filterContainsOperator' | translate}}"
                          filterDateToday="{{'filterDateToday' | translate}}" filterDateToggle="{{'filterDateToggle' | translate}}"
                          filterEndsWithOperator="{{'filterEndsWithOperator' | translate}}"
                          filterEqOperator="{{'filterEqOperator' | translate}}" filterFilterButton="{{'filterFilterButton' | translate}}"
                          filterGtOperator="{{'filterGtOperator' | translate}}" filterGteOperator="{{'filterGteOperator' | translate}}"
                          filterIsEmptyOperator="{{'filterIsEmptyOperator' | translate}}" filterIsFalse="{{'filterIsFalse' | translate}}"
                          filterIsNotEmptyOperator="{{'filterIsNotEmptyOperator' | translate}}"
                          filterIsNotNullOperator="{{'filterIsNotNullOperator' | translate}}"
                          filterIsNullOperator="{{'filterIsNullOperator' | translate}}" filterIsTrue="{{'filterIsTrue' | translate}}"
                          filterLtOperator="{{'filterLtOperator' | translate}}" filterLteOperator="{{'filterLteOperator' | translate}}"
                          filterNotContainsOperator="{{'filterNotContainsOperator' | translate}}"
                          filterNotEqOperator="{{'filterNotEqOperator' | translate}}"
                          filterNumericDecrement="{{'filterNumericDecrement' | translate}}"
                          filterNumericIncrement="{{'filterNumericIncrement' | translate}}" filterOrLogic="{{'filterOrLogic' | translate}}"
                          filterStartsWithOperator="{{'filterStartsWithOperator' | translate}}" loading="{{'loading' | translate}}"
                          groupPanelEmpty="{{'groupPanelEmpty' | translate}}" lock="{{'lock' | translate}}" unlock="{{'unlock' | translate}}"
                          noRecords="{{'norecords' | translate}}" pagerItems="" pagerOf="/"></kendo-grid-messages>
                    </kendo-grid>
                    <div *ngIf="loadingAsociadosPadres" class="k-i-loading"></div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabArbolInferior" title="{{ 'arbolInferior' | translate}}">
                <ng-template kendoTabContent>
                    <kendo-grid [kendoGridBinding]="dataAsociadosHijos" [sortable]="true" kendoGridSelectBy="idRelacion"
                        [navigable]="true" filterable="menu" [selectedKeys]="mySelectionHijos">
                        <ng-template kendoGridToolbarTemplate position="top">
                            <button kendoButton (click)="onClickAsignarRelacion()" class="btn mr-1  btn-success btn-sm mr-1"> {{
                                'asignar' | translate}} </button>
                            <button kendoButton (click)="onClickNuevoActivo()" class="btn mr-1  btn-primary btn-sm mr-1"> {{
                                'nuevo' | translate}} </button>
                            <button kendoButton (click)="onClickEliminarRelaciones()" class="btn mr-1  btn-danger btn-sm mr-1"
                                [disabled]="isDeletingHijos || this.user.activosMaestro<2"> {{ 'quitar' | translate}} </button>
                        </ng-template>
                        <kendo-grid-checkbox-column width="5%" showSelectAll="true"></kendo-grid-checkbox-column>
                        <kendo-grid-column width="20%" field="nombre" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="referencia" title="{{ 'referencia' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="jeraraquiaActivo"
                            title="{{ 'jerarquiaActivos' | translate}}"> </kendo-grid-column>
                        <kendo-grid-column width="20%" field="vidaUtil" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column field="stock" title="{{ 'stock' | translate}}" width="10%">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <input type="checkbox" [checked]="dataItem.stock" disabled />
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column [style]="{'text-align': 'right'}"  width="10%">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              <button type="button" class="btn-icon" (click)="viewLowerTree(dataItem)" ><i class="fa fa-sitemap" aria-hidden="true"></i></button>
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-messages filter="{{'filter' | translate}}" filterAfterOperator="{{'filterAfterOperator' | translate}}"
                          filterAfterOrEqualOperator="{{'filterAfterOrEqualOperator' | translate}}"
                          filterAndLogic="{{'filterAndLogic' | translate}}" filterBeforeOperator="{{'filterBeforeOperator' | translate}}"
                          filterBeforeOrEqualOperator="{{'filterBeforeOrEqualOperator' | translate}}"
                          filterBooleanAll="{{'filterBooleanAll' | translate}}" filterClearButton="{{'filterClearButton' | translate}}"
                          filterContainsOperator="{{'filterContainsOperator' | translate}}"
                          filterDateToday="{{'filterDateToday' | translate}}" filterDateToggle="{{'filterDateToggle' | translate}}"
                          filterEndsWithOperator="{{'filterEndsWithOperator' | translate}}"
                          filterEqOperator="{{'filterEqOperator' | translate}}" filterFilterButton="{{'filterFilterButton' | translate}}"
                          filterGtOperator="{{'filterGtOperator' | translate}}" filterGteOperator="{{'filterGteOperator' | translate}}"
                          filterIsEmptyOperator="{{'filterIsEmptyOperator' | translate}}" filterIsFalse="{{'filterIsFalse' | translate}}"
                          filterIsNotEmptyOperator="{{'filterIsNotEmptyOperator' | translate}}"
                          filterIsNotNullOperator="{{'filterIsNotNullOperator' | translate}}"
                          filterIsNullOperator="{{'filterIsNullOperator' | translate}}" filterIsTrue="{{'filterIsTrue' | translate}}"
                          filterLtOperator="{{'filterLtOperator' | translate}}" filterLteOperator="{{'filterLteOperator' | translate}}"
                          filterNotContainsOperator="{{'filterNotContainsOperator' | translate}}"
                          filterNotEqOperator="{{'filterNotEqOperator' | translate}}"
                          filterNumericDecrement="{{'filterNumericDecrement' | translate}}"
                          filterNumericIncrement="{{'filterNumericIncrement' | translate}}" filterOrLogic="{{'filterOrLogic' | translate}}"
                          filterStartsWithOperator="{{'filterStartsWithOperator' | translate}}" loading="{{'loading' | translate}}"
                          groupPanelEmpty="{{'groupPanelEmpty' | translate}}" lock="{{'lock' | translate}}" unlock="{{'unlock' | translate}}"
                          noRecords="{{'norecords' | translate}}" pagerItems="" pagerOf="/"></kendo-grid-messages>
                    </kendo-grid>
                    <div *ngIf="loadingAsociadosHijos" class="k-i-loading"></div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabProveedor" title="{{ 'proveedor' | translate}}">
                <ng-template kendoTabContent>
                    <kendo-grid [kendoGridBinding]="dataProveedores" [sortable]="true" kendoGridSelectBy="idProveedor"
                        [navigable]="true" filterable="menu" [selectedKeys]="mySelectionProveedores" (cellClick)="onCellClickProveedor($event)">
                        <ng-template kendoGridToolbarTemplate position="top">
                            <button kendoButton (click)="onClickAsignarProveedor()" class="btn mr-1  btn-success btn-sm mr-1"> {{
                                'asignar' | translate}} </button>
                            <button kendoButton (click)="onClickNuevoProveedor()" class="btn mr-1  btn-primary btn-sm mr-1"> {{
                                'nuevo' | translate}} </button>
                            <button kendoButton (click)="onClickEliminarProveedor()" class="btn mr-1  btn-danger btn-sm mr-1"
                                [disabled]="isDeletingProveedores || this.user.activosMaestro<2"> {{ 'eliminar' | translate}} </button>
                        </ng-template>
                        <kendo-grid-checkbox-column width="5%" showSelectAll="true"></kendo-grid-checkbox-column>
                        <kendo-grid-column width="20%" field="nombre" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="precio" title="{{ 'precio' | translate}}">
                            <ng-template kendoGridCellTemplate let-dataItem>{{dataItem.precio.toFixed(2)}}</ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="plazoEntrega" title="{{ 'plazoEntrega' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="20%" field="garantia" title="{{ 'garantia' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column field="observaciones" title="{{ 'observaciones' | translate}}" width="10%">
                        </kendo-grid-column>
                        <kendo-grid-messages filter="{{'filter' | translate}}" filterAfterOperator="{{'filterAfterOperator' | translate}}"
                        filterAfterOrEqualOperator="{{'filterAfterOrEqualOperator' | translate}}"
                        filterAndLogic="{{'filterAndLogic' | translate}}" filterBeforeOperator="{{'filterBeforeOperator' | translate}}"
                        filterBeforeOrEqualOperator="{{'filterBeforeOrEqualOperator' | translate}}"
                        filterBooleanAll="{{'filterBooleanAll' | translate}}" filterClearButton="{{'filterClearButton' | translate}}"
                        filterContainsOperator="{{'filterContainsOperator' | translate}}"
                        filterDateToday="{{'filterDateToday' | translate}}" filterDateToggle="{{'filterDateToggle' | translate}}"
                        filterEndsWithOperator="{{'filterEndsWithOperator' | translate}}"
                        filterEqOperator="{{'filterEqOperator' | translate}}" filterFilterButton="{{'filterFilterButton' | translate}}"
                        filterGtOperator="{{'filterGtOperator' | translate}}" filterGteOperator="{{'filterGteOperator' | translate}}"
                        filterIsEmptyOperator="{{'filterIsEmptyOperator' | translate}}" filterIsFalse="{{'filterIsFalse' | translate}}"
                        filterIsNotEmptyOperator="{{'filterIsNotEmptyOperator' | translate}}"
                        filterIsNotNullOperator="{{'filterIsNotNullOperator' | translate}}"
                        filterIsNullOperator="{{'filterIsNullOperator' | translate}}" filterIsTrue="{{'filterIsTrue' | translate}}"
                        filterLtOperator="{{'filterLtOperator' | translate}}" filterLteOperator="{{'filterLteOperator' | translate}}"
                        filterNotContainsOperator="{{'filterNotContainsOperator' | translate}}"
                        filterNotEqOperator="{{'filterNotEqOperator' | translate}}"
                        filterNumericDecrement="{{'filterNumericDecrement' | translate}}"
                        filterNumericIncrement="{{'filterNumericIncrement' | translate}}" filterOrLogic="{{'filterOrLogic' | translate}}"
                        filterStartsWithOperator="{{'filterStartsWithOperator' | translate}}" loading="{{'loading' | translate}}"
                        groupPanelEmpty="{{'groupPanelEmpty' | translate}}" lock="{{'lock' | translate}}" unlock="{{'unlock' | translate}}"
                        noRecords="{{'norecords' | translate}}" pagerItems="" pagerOf="/"></kendo-grid-messages>
                    </kendo-grid>
                    <div *ngIf="loadingProveedores" class="k-i-loading"></div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabGestionDocumental" title="{{ 'gestiondocumental' | translate}}">
                <ng-template kendoTabContent>
                    <kendo-grid [kendoGridBinding]="dataGestionDocumental" [sortable]="true"
                        kendoGridSelectBy="id" [navigable]="true" filterable="menu" (cellClick)="onCellClickGestionDocumental($event)"
                        [selectedKeys]="mySelectionGestionDocumental">
                        <ng-template kendoGridToolbarTemplate position="top">
                            <button kendoButton (click)="onClickEditarGestionDocumental()"
                                class="btn mr-1  btn-success btn-sm mr-1"> {{
                                'editar' | translate}} </button>
                            <button kendoButton (click)="onClickNuevoGestionDocumental()"
                                class="btn mr-1  btn-primary btn-sm mr-1"> {{
                                'nuevo' | translate}} </button>
                            <button kendoButton (click)="onClickEliminarGestionDocumental()" 
                                class="btn mr-1  btn-danger btn-sm mr-1" [disabled]="loadingGestionDocumental || this.user.activosMaestro<2"> {{ 'eliminar' |
                                translate}} </button>
                        </ng-template>
                        <kendo-grid-checkbox-column width="5%" showSelectAll="true"></kendo-grid-checkbox-column>
                        <kendo-grid-column width="40%" field="nombre" title="{{ 'nombre' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column width="40%" field="ficheroLink" title="{{ 'fichero' | translate}}">
                        </kendo-grid-column>
                        <kendo-grid-column [style]="{'text-align': 'right'}"  width="10%">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              <button type="button" class="btn-icon" (click)="viewPDF(dataItem)" ><span class="k-icon k-i-file-pdf"></span></button>
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-messages filter="{{'filter' | translate}}" filterAfterOperator="{{'filterAfterOperator' | translate}}"
                          filterAfterOrEqualOperator="{{'filterAfterOrEqualOperator' | translate}}"
                          filterAndLogic="{{'filterAndLogic' | translate}}" filterBeforeOperator="{{'filterBeforeOperator' | translate}}"
                          filterBeforeOrEqualOperator="{{'filterBeforeOrEqualOperator' | translate}}"
                          filterBooleanAll="{{'filterBooleanAll' | translate}}" filterClearButton="{{'filterClearButton' | translate}}"
                          filterContainsOperator="{{'filterContainsOperator' | translate}}"
                          filterDateToday="{{'filterDateToday' | translate}}" filterDateToggle="{{'filterDateToggle' | translate}}"
                          filterEndsWithOperator="{{'filterEndsWithOperator' | translate}}"
                          filterEqOperator="{{'filterEqOperator' | translate}}" filterFilterButton="{{'filterFilterButton' | translate}}"
                          filterGtOperator="{{'filterGtOperator' | translate}}" filterGteOperator="{{'filterGteOperator' | translate}}"
                          filterIsEmptyOperator="{{'filterIsEmptyOperator' | translate}}" filterIsFalse="{{'filterIsFalse' | translate}}"
                          filterIsNotEmptyOperator="{{'filterIsNotEmptyOperator' | translate}}"
                          filterIsNotNullOperator="{{'filterIsNotNullOperator' | translate}}"
                          filterIsNullOperator="{{'filterIsNullOperator' | translate}}" filterIsTrue="{{'filterIsTrue' | translate}}"
                          filterLtOperator="{{'filterLtOperator' | translate}}" filterLteOperator="{{'filterLteOperator' | translate}}"
                          filterNotContainsOperator="{{'filterNotContainsOperator' | translate}}"
                          filterNotEqOperator="{{'filterNotEqOperator' | translate}}"
                          filterNumericDecrement="{{'filterNumericDecrement' | translate}}"
                          filterNumericIncrement="{{'filterNumericIncrement' | translate}}" filterOrLogic="{{'filterOrLogic' | translate}}"
                          filterStartsWithOperator="{{'filterStartsWithOperator' | translate}}" loading="{{'loading' | translate}}"
                          groupPanelEmpty="{{'groupPanelEmpty' | translate}}" lock="{{'lock' | translate}}" unlock="{{'unlock' | translate}}"
                          noRecords="{{'norecords' | translate}}" pagerItems="" pagerOf="/"></kendo-grid-messages>
                    </kendo-grid>
                    <div *ngIf="loadingGestionDocumental" class="k-i-loading"></div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabPreventivo" title="{{ 'preventivo' | translate}}" [disabled]="true">
                <ng-template kendoTabContent>
                    PREVENTIVO
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabArbolDCA" title="{{ 'arbolDCA' | translate}}" [disabled]="true">
                <ng-template kendoTabContent>
                    ÁRBOL DCA
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
    <div class="form-group mt-2">

        <button type="submit" class="btn btn-primary btn-sm mr-1" (click)="guardarClick()" [disabled]="this.user.activosMaestro<2">
            {{ 'guardar' | translate}}
        </button>
        <button type="submit" class="btn btn-danger btn-sm mr-1" [routerLink]="['/activosMaestros']">
            {{ 'cancelar' | translate}}
        </button>
    </div>
</form>



<ng-template #modalIsometrico let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ 'isometrico' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <kendo-tabstrip [keepTabContent]="true" class="tabstrip-activos-isometricos">
            <kendo-tabstrip-tab id="tabMaquinasIsometrico" title="{{ 'maquinas' | translate}}" [selected]="true">
                <ng-template kendoTabContent>
                    <!-- DIBUJOS MÁQUINAS ISOMÉTRICO -->
                    <div *ngIf="dibujosMaquinas">
                        <div class="activos-detalle-isometrico row">
                            <ng-container *ngFor="let iconoMaq of dibujosMaquinas;">
                                <div class="col-2">
                                    <img class="clickable" [ngClass]="{'actual': iconoMaq.id == selectedAuxiliarDibujo.id}" (click)="selectedAuxiliarDibujo= iconoMaq;"
                                        src="{{iconoMaq.imagen}}" />
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab id="tabObjetosIsometrico" title="{{ 'objetos' | translate}}">
                <ng-template kendoTabContent>
                    <!-- DIBUJOS OBJETOS ISOMÉTRICO -->
                    <div *ngIf="dibujosObjetos">
                        <div class="activos-detalle-isometrico row">
                            <ng-container *ngFor="let iconoObj of dibujosObjetos;">
                                <div class="col-2">
                                    <img class="clickable" [ngClass]="{'actual': iconoObj.id == selectedAuxiliarDibujo.id}" (click)="selectedAuxiliarDibujo= iconoObj;"
                                        src="{{iconoObj.imagen}}" />
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="guardarIsometrico()" [disabled]="this.user.activosMaestro<2">{{ 'guardar' |
            translate }}</button>
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel click')">{{ 'cancelar' | translate
            }}</button>
    </div>
</ng-template>

<!-- POPUP: Borrar -->
<ng-template #popupBorrarProveedores let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title"></h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <label>{{'preguntaeliminarpopup' | translate }}</label>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="btnBorrarAceptar()" [disabled]="this.user.activosMaestro<2">{{ 'aceptar' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel click')">{{ 'cancelar' | translate
            }}</button>
    </div>
</ng-template>

<ng-template #popupBorrarRelaciones let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title"></h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <label>{{'preguntaeliminarpopup' | translate }}</label>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="btnBorrarAceptarRelaciones()" [disabled]="this.user.activosMaestro<2">{{ 'aceptar' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel click')">{{ 'cancelar' | translate
            }}</button>
    </div>
</ng-template>

<ng-template #popupBorrarDocumentos let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title"></h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <label>{{'preguntaeliminarpopup' | translate }}</label>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="btnBorrarDocumentos()" [disabled]="this.user.activosMaestro<2">{{ 'aceptar' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel click')">{{ 'cancelar' | translate
            }}</button>
    </div>
</ng-template>